
export const WhopIcon = () => {
    return (
      <img src="https://whop.com/oauth/whop-logo-square.png" alt="WhopIcon" width="32" height="32" />
    );
};
